interface Props {
    size?: number;
    /** Suffix to make SVG gradient/filter ids unique across mounted instances. */
    idSuffix?: string;
}

/**
 * Glowing line silhouette of the Rust "Tempered Metal Facemask"
 * (public/tempered.png). The outline + eye slots are auto-traced from the image
 * and uniformly scaled into the viewBox, so proportions match the source exactly.
 */
const BrandLogo = ({ size = 32, idSuffix = 'sb' }: Props) => {
    const gradId = `rbGrad-${idSuffix}`;
    const glowId = `rbGlow-${idSuffix}`;

    return (
        <svg
            viewBox="0 0 40 40"
            width={size}
            height={size}
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            className="shrink-0"
        >
            <defs>
                <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#8b6dff" />
                    <stop offset="0.55" stopColor="#b78dff" />
                    <stop offset="1" stopColor="#3ad6ff" />
                </linearGradient>
                <filter id={glowId} x="-60%" y="-60%" width="220%" height="220%">
                    <feGaussianBlur stdDeviation="1.05" result="b" />
                    <feMerge>
                        <feMergeNode in="b" />
                        <feMergeNode in="b" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>

            <g
                fill="none"
                stroke={`url(#${gradId})`}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                filter={`url(#${glowId})`}
            >
                {/* mask outline (traced) */}
                <path d="M16.99 2 L21.65 2.68 L24.28 4.1 L25.56 5.08 L28.19 8.01 L28.87 7.94 L29.09 8.16 L30.45 10.79 L31.35 13.72 L31.27 16.58 L32.1 19.44 L32.78 20.34 L32.85 21.47 L32.18 32.89 L31.65 34.62 L30.15 35.9 L27.97 37.02 L25.04 37.7 L22.1 38 L19.62 37.85 L17.9 37.4 L14.96 36.42 L14.21 35.44 L13.24 30.03 L12.41 28.23 L10.91 21.39 L9.63 20.64 L8.35 19.21 L7.3 15.6 L7.15 12.97 L7.45 11.09 L8.28 8.76 L9.63 6.58 L11.96 4.25 L14.66 2.68 L16.92 2.08 Z" />
                {/* left / centre eye slot (traced) */}
                <path d="M20.75 21.16 L22.25 21.32 L23.31 22.07 L23.38 22.74 L22.78 23.57 L22.03 24.1 L19.47 24.4 L17.22 24.47 L16.17 24.32 L15.64 23.95 L15.49 23.19 L16.02 21.69 L16.92 21.39 L20.68 21.24 Z" />
                {/* right eye slot (traced) */}
                <path d="M30.45 18.99 L31.12 20.94 L31.12 21.54 L30.22 22.14 L29.62 22.14 L29.85 19.36 L30.37 19.06 Z" />
            </g>
        </svg>
    );
};

export default BrandLogo;
